import React, { useEffect, useState } from 'react';
import { applicantAPI } from '@/services/api';
import { Shield, Check, X } from 'lucide-react';
import Pagination, { usePagination } from '@/components/shared/Pagination';

export default function ApplicantRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const pg = usePagination(requests, 20);

  useEffect(() => { applicantAPI.getAccessRequests().then(setRequests).catch(() => { /* noop */ }).finally(() => setLoading(false)); }, []);

  const respond = async (id, action) => {
    try {
      await applicantAPI.respondToRequest(id, action);
      setRequests(requests.map(r => r.id === id ? { ...r, status: action === 'approve' ? 'approved' : 'rejected' } : r));
    } catch (e) { alert(e.response?.data?.detail || e.message); }
  };

  return (
    <div data-testid="applicant-requests">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-1">Access Requests</h1>
      <p className="text-slate-500 dark:text-zinc-500 text-sm mb-6">Manage who can see your data</p>
      {loading ? <p className="text-slate-500 dark:text-zinc-500">Loading...</p> : requests.length === 0 ? (
        <div className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-10 text-center"><Shield className="w-10 h-10 text-slate-600 dark:text-zinc-700 mx-auto mb-3" /><p className="text-slate-500 dark:text-zinc-500">No access requests</p></div>
      ) : (
        <div className="space-y-3">
          {pg.pageItems.map(r => (
            <div key={r.id} className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-4 flex items-center justify-between">
              <div>
                <p className="text-slate-900 dark:text-white text-sm">Request from Recruiter</p>
                <p className="text-slate-500 dark:text-zinc-500 text-xs">Fields: {r.requested_fields?.join(', ')} &middot; <span className="capitalize">{r.status.replace('_', ' ')}</span></p>
                <p className="text-slate-500 dark:text-zinc-600 text-xs">Expires: {new Date(r.expires_at).toLocaleDateString()}</p>
              </div>
              {r.status === 'pending' && (
                <div className="flex gap-2">
                  <button onClick={() => respond(r.id, 'approve')} className="p-2 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 rounded-lg hover:bg-emerald-500/20" data-testid={`approve-${r.id}`}><Check className="w-4 h-4" /></button>
                  <button onClick={() => respond(r.id, 'reject')} className="p-2 bg-red-500/10 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-500/20" data-testid={`reject-${r.id}`}><X className="w-4 h-4" /></button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <Pagination {...pg.paginationProps} testIdPrefix="applicant-requests-pg" />
    </div>
  );
}
